import { render, staticRenderFns } from "./InputWidget.vue?vue&type=template&id=313dcbbc&scoped=true"
import script from "./InputWidget.vue?vue&type=script&lang=js"
export * from "./InputWidget.vue?vue&type=script&lang=js"
import style0 from "./InputWidget.vue?vue&type=style&index=0&id=313dcbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dcbbc",
  null
  
)

export default component.exports